<template>
    <div> 
        <el-cascader v-if="Options" style="width: 100%" :value="DataId" :size="size || config.Size" :props="Propertys"
            :options="Options" @change="OnInputObject" :disabled="disabled || config.Disabled"
            :placeholder="'请输入' + (config.Title || '')" clearable :filterable="Options && Options.length > 0"
            :multiple="true" @focus="OnLoad" :collapse-tags="true">
            <template slot-scope="{ data }">
                <mx-panel :panel="Panel" v-if="Panel" :value="data"></mx-panel>
            </template>
        </el-cascader>

    </div>
</template>
<script>
import base from 'matrix.node.ui/field.js'
import panels from '@/projects/panels/index'
let emptyStrHanlder = function () {
    return undefined
}
let dataHandler = function (data) {
    return data
}
export default {
    data() {
        return { DataOptions: null }
    },
    mixins: [base.edit(Array, emptyStrHanlder, emptyStrHanlder, dataHandler)],
    props: {
        isEnd: Boolean,
        isLoading: Boolean,
        options: Array
    },
    computed: {
        Panel() {
            let name = (this.config.Link + '.Field').replace(/\./g, '_')
            if (panels[name]) return name
            return ''
        },
        DataId() {
            let v =
                this.Data && this.Data.map
                    ? this.Data.map((t) => {
                        if (t) {
                            if (t.Id) return t.Id
                            return t
                        }
                    }).filter((t) => {
                        return !!t
                    })
                    : []
            if (v.length === 0) return
            return v
        },
        LabelField() {
            if (this.config && this.config.LabelField)
                return this.config.LabelField
            if (this.config && this.config.Options && this.config.Options.Label)
                return this.config.Options.Label
            return 'Title'
        },
        ParentField() {
            if (
                this.config &&
                this.config.Options &&
                this.config.Options.ParentField
            )
                return this.config.Options.ParentField
            return 'Parent'
        },
        Label() {
            if (this.value) {
                return this.value[this.LabelField]
            }
            return ''
        },
        Propertys() {
            return {
                label: this.LabelField,
                value: 'Id',
                checkStrictly: this.CheckStrictly,
                emitPath: false,
                multiple: true
            }
        },
        CheckStrictly() {
            return (
                this.config.CheckStrictly ||
                (this.config.Name === 'Parent' &&
                    this.config.Link === this.config.Options.Entity)
            )
        },
        Options() {
            let result = []
            let selections = this.options || this.selections || []
            if (
                this.value &&
                this.value.Id &&
                (!selections ||
                    !selections.find((t) => {
                        return t.Id === this.value.Id
                    }))
            ) {
                result = result.concat([this.value])
            }
            if (selections && selections.length > 0) {
                result = result.concat(selections)
                let getParent = (p) => {
                    return p && p.Id === undefined ? p : p.Id
                }
                let findchild = (pid) => {
                    let child = result
                        .filter((r) => {
                            return (
                                (r[this.ParentField] &&
                                    getParent(r[this.ParentField]) === pid) ||
                                (pid === 0 && !r[this.ParentField])
                            )
                        })
                        .map((c) => {
                            let children = findchild(c.Id)
                            if (children && children.length > 0)
                                c.children = children
                            return c
                        })
                    return child
                }
                let categroys = findchild(0)
                if (categroys && categroys.length === 0 && result.length)
                    return result
                return categroys
            } else {
                return result
            }
        }
    },
    methods: {
        OnLoad() {
            let selections = this.selections || this.options || []
            if (!selections || selections.length === 0) {
                let fields = ['Id']
                fields.push(this.LabelField)
                if (this.config.Options.Level > 1 && this.ParentField)
                    fields.push(this.ParentField)
                if (this.Panel) {
                    fields = []
                }

                this.$emit('load', {
                    type: 'LoadSelections',
                    params: Object.assign(
                        {
                            Page: 1,
                            PageSize: 0,
                            Fields: fields,
                            ['Get' + this.ParentField]: false
                        },
                        this.config.Options.Params
                    ),
                    role: this.config.Role,
                    rolefield: this.config.RoleField
                })
            }
        },
        OnInputObject(val) {
            let selections = this.selections || this.options || []
            if (typeof val === 'number') {
                let id = val
                let op = selections.find((t) => {
                    return t.Id === id
                })
                this.Data = [op]
                this.OnChange()
            } else if (val) {
                if (val.length > 0) {
                    this.Data = selections.filter((t) => {
                        return val.indexOf(t.Id) > -1
                    })
                } else {
                    this.Data = []
                }
                this.OnChange()
            } else {
                this.Data = []
                this.OnChange()
            }
        }
    },
    created() {
        if (this.value && this.value.length > 0) {
            this.OnLoad()
        }
    }
}
</script>